import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Category1 from '../images/Hero1.jpg'; // Placeholder image
import Category2 from '../images/Hero2.jpg';
import Category3 from '../images/Hero3.jpg';

const ShowMoreProducts = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('All');
  const products = [
    {
      id: 1,
      name: 'Apple iPad Mini 6 Wi-Fi Cellular 64GB/128GB',
      price: 56.00,
      originalPrice: 75.00,
      discount: '-43%',
      imageUrl: Category1,
      reviews: 10,
      category: 'Tablets',
    },
    {
      id: 2,
      name: 'Apple iPad Pro 11" Wi-Fi Cellular 128GB',
      price: 85.00,
      originalPrice: 100.00,
      discount: '-15%',
      imageUrl: Category2,
      reviews: 20,
      category: 'Tablets',
    },
    {
      id: 3,
      name: 'Apple iPad Air 4 Wi-Fi Cellular 64GB',
      price: 60.00,
      originalPrice: 80.00,
      discount: '-25%',
      imageUrl: Category3,
      reviews: 15,
      category: 'Tablets',
    },
    // Add more product objects as needed
  ];

  // Filtered Products based on category selection
  const filteredProducts = selectedCategory === 'All' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <div className="container mx-auto pt-40 px-4 py-6 bg-gray-50">
      <h2 className="text-3xl font-semibold text-gray-800 mb-6">Our Product Collection</h2>

      {/* Filter Section */}
      <div className="flex items-center gap-4 mb-8">
        <button
          onClick={() => setSelectedCategory('All')}
          className={`px-4 py-2 rounded-md ${selectedCategory === 'All' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-800'}`}
        >
          All
        </button>
        <button
          onClick={() => setSelectedCategory('Tablets')}
          className={`px-4 py-2 rounded-md ${selectedCategory === 'Tablets' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-800'}`}
        >
          Tablets
        </button>
        <button
          onClick={() => setSelectedCategory('Accessories')}
          className={`px-4 py-2 rounded-md ${selectedCategory === 'Accessories' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-800'}`}
        >
          Accessories
        </button>
        {/* Add more category buttons as needed */}
      </div>

      {/* Products Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {filteredProducts.map((product) => (
          <div
            key={product.id}
            className="p-4 bg-white rounded-lg shadow-lg transform transition-transform hover:scale-105 duration-300 cursor-pointer"
            onClick={() => navigate(`/product/${product.id}`)}
          >
            <img
              src={product.imageUrl}
              alt={product.name}
              className="w-full h-40 object-cover rounded-lg mb-4 hover:opacity-80 transition-opacity duration-300"
            />
            <h3 className="font-semibold text-lg text-gray-800">{product.name}</h3>
            <div className="flex items-center gap-2">
              <p className="text-lg font-bold text-red-600">${product.price.toFixed(2)}</p>
              <p className="text-sm text-gray-500 line-through">${product.originalPrice.toFixed(2)}</p>
            </div>
            <p className="text-sm text-green-500">{product.discount}</p>
            <p className="text-sm text-yellow-500">{'★'.repeat(Math.floor(product.reviews / 10))}{'☆'.repeat(5 - Math.floor(product.reviews / 10))} ({product.reviews} reviews)</p>
            <button className="mt-3 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors duration-300">
              View Product
            </button>
          </div>
        ))}
      </div>

      {/* Pagination or Load More Button */}
      <div className="mt-8 flex justify-center">
        <button className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors duration-300">
          Load More Products
        </button>
      </div>
    </div>
  );
};

export default ShowMoreProducts;
